import { Link as RouterLink } from "@tanstack/react-router"

import { Logo } from "@/brand/components/logo"
import { TwitterIcon } from "@/brand/components/social"
import { CoreTechStackLogos } from "@/brand/components/tech-stack-logos"
import config from "@/config"
import { Button } from "@/ui/button"
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/ui/card"
import { cn } from "@/ui/utils"

interface CtaBannerProps {
  className?: string
}

function CtaBanner({ className }: CtaBannerProps) {
  return (
    <aside className={cn("mt-16", className)}>
      <Card>
        <CardHeader className="justify-items-center gap-6 text-center">
          <CardTitle className="inline-flex items-center gap-2 text-2xl">
            <Logo className="size-12" />
            {config.core.projectName}
          </CardTitle>
          <CardDescription className="text-md">
            Open source,{" "}
            <span className="underline decoration-orange-500 decoration-2 underline-offset-4">
              Cloudflare-native
            </span>{" "}
            web app starter for the AI era
          </CardDescription>
        </CardHeader>
        <CardContent className="py-2">
          <CoreTechStackLogos />
        </CardContent>
        <CardFooter className="justify-center">
          <Button asChild>
            <RouterLink to="/">Learn more</RouterLink>
          </Button>
          <Button asChild variant="outline">
            <a href="https://x.com/pawelgalazka" target="_blank" rel="noopener noreferrer">
              <TwitterIcon />
              Follow
            </a>
          </Button>
        </CardFooter>
      </Card>
    </aside>
  )
}

export { CtaBanner, type CtaBannerProps }
